export const APP_NAME = 'sixense-image-search';
export const PANEL_WIDTH = {
  searchImages: 300,
  about: 370,
  alert: 480,
  profile: 400
};
export const CARDS_WIDTH = 350;
export const HORIZONTAL_DISPLACEMENT_PANEL = 70;

export const INITIAL_VIEWPORT = {
  latitude: 41.4,
  longitude: 2.2,
  zoom: 5,
  bearing: 0,
  pitch: 0
};

export const INITIAL_MAPSTYLE = 'mapStyles/hybrid.json';

export const API_URL = process.env.API_BASE_URL || 'https://sixense-image-search.geomatico.es/api/v1/';
